import __base_store from '@/store/__base_store'

/**
 * Store de categorías de egreso (modelo `expense_category`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'expense_category',
	},
})

